module.exports = __webpack_public_path__ + "img/LizMar.0df9143d.jpg";